/* Pure Vitamins UK multi-pack quantity tiles.
   Injects a pack-size selector directly above Add to Cart on product pages.
   The tiles only set the quantity field. The saving itself comes from the
   store's automatic quantity discount, so the two can never drift apart in
   a way that overcharges: if the discount is paused, the customer simply pays
   full price and the tile copy is the only thing that is stale.

   3 Sep 2026: the store discount is now SAME PRODUCT ONLY (Simple Discounts,
   "Quantity tier discount"), and it no longer combines with product discount
   codes such as WELCOME20. Shopify applies whichever saving is larger, never
   both. The note under the tiles says so. If either of those rules changes,
   change the note too.

   12 Oct 2026: tile prices now match the basket to the penny. The discount
   app takes the percentage off each unit and rounds the discount DOWN to the
   penny (e.g. 10% of 1199p = 119.9p, so 119p off, 1080p each). The tiles
   previously rounded the unit price instead, which showed 1079p.

   Labels are written already capitalised here rather than relying on CSS,
   because the theme applies text-transform to buttons and we override it.

   Fails silently. If the theme markup changes and the anchors are not found,
   the page renders exactly as it does without this file. */
(function () {
  'use strict';
  if (!window.PV_QTY || window.__pvQtyInit) return;
  window.__pvQtyInit = true;

  var cfg = window.PV_QTY;
  if (!cfg.price || !cfg.tiers || !cfg.tiers.length) return;

  var fmt;
  try {
    fmt = new Intl.NumberFormat('en-GB', { style: 'currency', currency: cfg.currency || 'GBP' });
  } catch (e) {
    fmt = { format: function (n) { return '£' + n.toFixed(2); } };
  }
  function money(pence) { return fmt.format(pence / 100); }

  function span(cls, text) {
    var el = document.createElement('span');
    el.className = cls;
    el.textContent = text;
    return el;
  }

  function build(form) {
    if (form.querySelector('.pv-qty')) return;

    var qtyInput = form.querySelector('input[name="quantity"]');
    var submit = form.querySelector('button[name="add"], [type="submit"]');
    if (!qtyInput || !submit) return;

    var wrap = document.createElement('div');
    wrap.className = 'pv-qty';

    var label = document.createElement('p');
    label.className = 'pv-qty__label';
    label.textContent = 'Choose your pack';
    wrap.appendChild(label);

    var grid = document.createElement('div');
    grid.className = 'pv-qty__grid';
    grid.setAttribute('role', 'radiogroup');
    grid.setAttribute('aria-label', 'Pack size');
    wrap.appendChild(grid);

    cfg.tiers.forEach(function (t, i) {
      var unit = cfg.price - Math.floor((cfg.price * t.off) / 100);
      var total = unit * t.q;
      var name = t.q === 1 ? '1 Pack' : t.q + ' Packs';

      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'pv-qty__tile';
      tile.setAttribute('role', 'radio');
      tile.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
      tile.setAttribute('data-qty', String(t.q));
      tile.setAttribute('aria-label', name + ', ' + money(unit) + ' each, ' + money(total) + ' total' + (t.off ? ', save ' + t.off + ' percent' : ''));

      var row = document.createElement('span');
      row.className = 'pv-qty__row';
      row.appendChild(span('pv-qty__n', name));
      if (t.off) row.appendChild(span('pv-qty__flag', 'Save ' + t.off + '%'));
      tile.appendChild(row);

      tile.appendChild(span('pv-qty__unit', money(unit) + ' each'));
      tile.appendChild(span('pv-qty__total', money(total) + ' total'));

      grid.appendChild(tile);
    });

    var note = document.createElement('p');
    note.className = 'pv-qty__note';
    note.textContent = 'Applies to this product only, added automatically at checkout. Discount codes are not added on top.';
    wrap.appendChild(note);

    grid.addEventListener('click', function (e) {
      var tile = e.target && e.target.closest ? e.target.closest('.pv-qty__tile') : null;
      if (!tile) return;
      var tiles = grid.querySelectorAll('.pv-qty__tile');
      for (var i = 0; i < tiles.length; i++) {
        tiles[i].setAttribute('aria-checked', tiles[i] === tile ? 'true' : 'false');
      }
      qtyInput.value = tile.getAttribute('data-qty');
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('.pv-qty__tile'));
      var current = tiles.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0];
      var idx = tiles.indexOf(current);
      if (idx < 0) return;
      e.preventDefault();
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : -1;
      var next = tiles[(idx + step + tiles.length) % tiles.length];
      next.click();
      next.focus();
    });

    submit.parentNode.insertBefore(wrap, submit);
  }

  function boot() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      // 24 Oct 2026: never inject tiles into the mobile sticky Add to Cart bar.
      if (forms[i].closest && forms[i].closest('.sticky-atc-bar')) continue;
      build(forms[i]);
    }
  }

  /* 24 Oct 2026: the mobile sticky bar has its own form, which would add one
     pack with no subscription. Instead its button presses the main Add to
     Cart, so the chosen pack size and one-time/subscription choice always
     carry through. Capture phase, so it runs before the theme's handler. */
  function mainAddButton() {
    return document.querySelector('.product__block--buy_buttons form[action*="/cart/add"] button[name="add"]');
  }
  function proxySticky(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var inSticky = e.type === 'submit'
      ? t.closest('.sticky-atc-bar')
      : t.closest('.sticky-atc-bar button[name="add"], .sticky-atc-bar [type="submit"]');
    if (!inSticky) return;
    var main = mainAddButton();
    if (!main || main.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    main.click();
  }
  document.addEventListener('click', proxySticky, true);
  document.addEventListener('submit', proxySticky, true);

  /* 24 Oct 2026: the theme shows the sticky bar whenever the main button is
     not fully on screen, including at page load when it is still BELOW the
     fold. Mark the body once the shopper has scrolled PAST the main button;
     pv-product.css keeps the bar hidden until then. */
  function watchMainButton() {
    var main = mainAddButton();
    if (!main) {
      document.body.classList.add('pv-atc-passed');
      return;
    }
    // A scroll check rather than IntersectionObserver: a fast flick can jump
    // from "below the fold" to "above the fold" without the button ever
    // intersecting, and the observer then never fires.
    // Runs directly on scroll (one cheap measurement), not via
    // requestAnimationFrame, which some in-app browsers pause.
    function check() {
      document.body.classList.toggle('pv-atc-passed', main.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); watchMainButton(); });
  } else {
    boot();
    watchMainButton();
  }
  document.addEventListener('shopify:section:load', boot);
})();
